<template>
    <header class="flex flex-wrap gap-x-3 gap-y-2 w-full">
        <div class="flex-grow">
            <slot name="above-heading"></slot>
            <h1 class="text-left font-semibold text-3xl pb-0 whitespace-nowrap">{{ heading }}</h1>
            <slot name="subheading">
                <div v-if="subheading" class="text-sm text-gray-500">{{ subheading }}</div>
            </slot>
        </div>
        <div class="flex space-x-4">
            <div v-if="hasPigTypePicker">
                <PigTypePicker :slim="slimPigTypePicker" />
            </div>
            <div v-if="hasPeriodPicker">
                <PeriodRangeDropdown v-model:value="periodPickerDateString" />
            </div>
            <slot name="top-right"></slot>
        </div>
    </header>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import PeriodRangeDropdown from '@/components/ui/PeriodRangeDropdown.vue';
import PigTypePicker from '@/components/ui/PigTypePicker.vue';
import { store } from '@/plugins/store';
import { MutationType } from '@/plugins/store/mutations';

export default defineComponent({
    components: { PeriodRangeDropdown, PigTypePicker },
    props: {
        heading: {
            type: String,
            default: '',
        },
        subheading: {
            type: String,
            default: '',
        },
        hasPigTypePicker: {
            type: Boolean,
            default: false,
        },
        hasPeriodPicker: {
            type: Boolean,
            default: false,
        },
        slimPigTypePicker: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        periodPickerDateString: {
            get(): string {
                return store.state.periodPickerDateString;
            },
            set(newValue: string) {
                store.commit(MutationType.SetPeriodPickerDateString, newValue);
            },
        },
    },
});
</script>
